import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import { FieldGroup, FormButton, ChangesIndicator } from "@td/ui";
import { isEqual } from "lodash";
import { translate, I18n } from "@td/shared_utils";
import { DeleteButton } from "../components";
import { schemaFactory } from "../validations";
import { FIELD_TYPES_BY_SPECIALTY, FORM_FIELDS_BY_SPECIALTY } from "../constants";
import { useProviderPanels } from "../contexts/provider-panels-context";

const ProviderPanelForm = React.memo(({ initialValues, onSubmit, isDeletable, onDelete }) => {
  const { specialtyCode } = useProviderPanels();

  const validationSchemaFactory = useCallback(() => {
    return schemaFactory({ fields: FIELD_TYPES_BY_SPECIALTY[specialtyCode] });
  }, [specialtyCode]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchemaFactory}
      onSubmit={onSubmit}
    >
      {({ values }) => (
        <React.Fragment>
          {!isEqual(initialValues, values) && (
            <ChangesIndicator />
          )}

          <Form>
            {
              FORM_FIELDS_BY_SPECIALTY[specialtyCode].map((Component, index) => (
                <FieldGroup key={index}>
                  <Component />
                </FieldGroup>
              ))
            }

            <FormButton type="submit">
              {translate(null, "provider_panel.form", "save_button")}
            </FormButton>
            { isDeletable && (
              <DeleteButton
                type="button"
                onClick={onDelete}
              >
                <I18n scope="provider_panel.form" text="delete_button" />
              </DeleteButton>
              )
            }
          </Form>
        </React.Fragment>
      )}
    </Formik>
  );
});

ProviderPanelForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isDeletable: PropTypes.bool,
  onDelete: PropTypes.func
};

ProviderPanelForm.displayName = "ProviderPanelForm";

export default ProviderPanelForm;
